if (!customElements.get('runor-integrated-bundle')) {
  customElements.define('runor-integrated-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const source = this.querySelector('[data-rnp-config]');
      if (!source) return;
      try { this.config = JSON.parse(source.textContent); } catch { return; }
      this.config.packs ||= [];
      this.productInfo = this.closest('product-info');
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-rnp-id]');
      this.submit = document.getElementById(`ProductSubmitButton-${this.config.sectionId}`);
      if (!this.submit || !this.form) return;
      this.ready = true;
      this.sourceVariantId = this.config.initialVariant;
      this.error = this.querySelector('[data-rnp-error]');
      this.formatter = new Intl.NumberFormat(this.config.locale, {style:'currency',currency:this.config.currency});
      this.controller = new AbortController();
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-rnp-quantity]')) return;
        this.error.hidden = true;
        this.error.textContent = '';
        this.update();
      }, {signal:this.controller.signal});
      this.form.addEventListener('submit', event => this.add(event), {signal:this.controller.signal});
      // The original theme owns the size/colour picker, URL and product gallery.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (data.sectionId !== this.config.sectionId) return;
          this.sourceVariantId = data.variant?.id;
          this.pendingVariant = false;
          this.update();
        });
        this.unsubscribeOptions = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({data}) => {
          if (!this.productInfo?.contains(data.event?.target)) return;
          this.pendingVariant = true;
          this.update();
        });
      }
      this.querySelector('[data-rnp-fallback]').hidden = true;
      this.querySelector('[data-rnp-controls]').hidden = false;
      this.update();
      this.dataset.ready = 'true';
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribeVariant?.();
      this.unsubscribeOptions?.();
      this.ready = false;
    }

    get quantity() { return Number(this.querySelector('[data-rnp-quantity]:checked')?.value || 3); }
    get variant() {
      return this.config.variants.find(variant => String(variant.id) === String(this.sourceVariantId));
    }
    offer(quantity) {
      const variant = this.variant;
      if (!variant) return null;
      if (quantity === 1) return variant;
      return this.config.packs.find(pack =>
        String(pack.options[this.config.optionCount]) === String(quantity) &&
        variant.options.every((value,index) => pack.options[index] === value)
      ) || null;
    }
    money(cents) { return this.formatter.format(cents / 100).replace(/\u00a0/g, ' '); }

    update() {
      const variant = this.variant;
      const offer = this.offer(this.quantity);
      this.querySelectorAll('[data-rnp-offer]').forEach(card => {
        const quantity = Number(card.dataset.rnpOffer);
        const item = this.offer(quantity);
        card.dataset.available = String(Boolean(variant?.available && item?.available));
        card.querySelector('[data-rnp-total]').textContent = item ? this.money(item.price) : '—';
        const unit = card.querySelector('[data-rnp-unit]');
        if (unit) unit.textContent = item ? `${this.money(Math.round(item.price / quantity))} ${this.config.labels.perPair}` : this.config.labels.soldOut;
        const reference = card.querySelector('[data-rnp-reference]');
        if (reference) {
          reference.textContent = variant ? this.money(variant.price * quantity) : '';
          reference.hidden = !item || !variant || item.price >= variant.price * quantity;
        }
      });
      this.idInput.value = offer ? String(offer.id) : '';
      const available = Boolean(variant?.available && offer?.available);
      this.submit.disabled = Boolean(this.busy || this.pendingVariant || !available);
      this.submit.setAttribute('aria-disabled', String(this.submit.disabled));
      this.submit.querySelector('span').textContent = this.busy
        ? this.config.labels.adding : available ? this.config.labels.add : this.config.labels.soldOut;
      this.submit.classList.toggle('loading', Boolean(this.busy));
      this.submit.querySelector('.loading__spinner')?.classList.toggle('hidden', !this.busy);
      this.querySelectorAll('[data-rnp-quantity]').forEach(input => input.disabled = Boolean(this.busy));
      this.dataset.busy = String(Boolean(this.busy));
      this.form.setAttribute('aria-busy', String(Boolean(this.busy)));
    }

    async add(event) {
      event.preventDefault();
      const offer = this.offer(this.quantity);
      if (this.busy || this.pendingVariant || !this.variant?.available || !offer?.available) return;
      this.busy = true;
      this.error.hidden = true;
      this.update();
      const drawer = document.querySelector('cart-drawer');
      drawer?.setActiveElement?.(this.submit);
      const sections = drawer?.getSectionsToRender?.().map(section => section.id) || [];
      const request = {items:[{id:offer.id,quantity:1,properties:{_runor_native_pack:String(this.quantity)}}]};
      if (sections.length) {
        request.sections = sections;
        request.sections_url = window.location.pathname + window.location.search;
      }
      let confirmed = false;
      try {
        const response = await fetch(this.config.addUrl, {
          method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify(request)
        });
        const data = await response.json();
        if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || this.config.labels.error);
        confirmed = true;
        if (drawer?.renderContents && sections.every(id => typeof data.sections?.[id] === 'string')) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {source:'runor-native-bundle',productVariantId:offer.id,cartData:data});
          }
          document.dispatchEvent(new CustomEvent('runor:pack-added', {detail:{variantId:offer.id,quantity:this.quantity}}));
        } else {
          window.location.assign(this.config.cartUrl);
        }
      } catch (error) {
        if (confirmed) {
          window.location.assign(this.config.cartUrl);
          return;
        }
        this.error.textContent = error instanceof TypeError || error instanceof SyntaxError ? this.config.labels.uncertain : error.message;
        this.error.hidden = false;
      } finally {
        this.busy = false;
        this.update();
      }
    }
  });
}
